import { render, staticRenderFns } from "./ComparadorPropostas.vue?vue&type=template&id=6dd2692a&"
import script from "./ComparadorPropostas.vue?vue&type=script&lang=js&"
export * from "./ComparadorPropostas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\07.00\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd2692a')) {
      api.createRecord('6dd2692a', component.options)
    } else {
      api.reload('6dd2692a', component.options)
    }
    module.hot.accept("./ComparadorPropostas.vue?vue&type=template&id=6dd2692a&", function () {
      api.rerender('6dd2692a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Suprimentos/cotacoes/ComparadorPropostas.vue"
export default component.exports